import CreateConferenceButton from '@/components/button/CreateConferenceButton.tsx';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { parseMeetingUrl } from '@/lib/meeting-id.ts';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LuArrowRight } from 'react-icons/lu';
import { useNavigate } from 'react-router-dom';

export function CreateJoinMeetingSection() {
  const [rawId, setRawId] = useState<string>('');
  const [isFocused, setIsFocused] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const parsedId = useMemo(() => parseMeetingUrl(rawId), [rawId]);
  const isEmpty = rawId === '';
  const isInvalid = !isEmpty && !parsedId;
  const isValid = !isEmpty && parsedId;

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setRawId(value);
  };

  const getBorderClass = () => {
    if (isValid) return 'border-green-500';
    if (isInvalid) return 'border-red-400';
    if (isFocused) return 'border-indigo-600';
    return '';
  };

  return (
    <div className="flex items-end justify-center gap-4 md:gap-6">
      <CreateConferenceButton className="w-40" />

      <div className="w-40 relative">
        <Input
          placeholder={t('homepage.enterMeetingID')}
          value={rawId}
          className={`h-12 leading-[3rem] w-full rounded-full text-left pl-4 pr-10 border-indigo-200 
            focus-visible:ring-0 [&::placeholder]:text-center            
            ${getBorderClass()}`}
          onChange={handleInputChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && parsedId) {
              navigate(`/${parsedId}`);
            }
          }}
        />
        <Button
          className={`absolute right-2 top-1/2 -translate-y-1/2 p-0 h-8 w-8 rounded-full transition-colors duration-200 z-10 ${
            isValid
              ? 'text-green-500 hover:text-green-600 hover:bg-green-50'
              : 'text-indigo-400 hover:text-indigo-600 hover:bg-indigo-50'
          }`}
          variant="ghost"
          onClick={() => navigate(`/${parsedId}`)}
          disabled={!parsedId}
        >
          <LuArrowRight size={20} />
        </Button>
      </div>
    </div>
  );
}
